<template>
    <form class="login-form" @submit.prevent="login">
        <div class="form-group">
            <label for="otp">Code (otp)</label>
            <input class="pm-input" type="tel" id="otp" v-model="credentials.otp" autocomplete="off" required>
        </div>
        <button type="submit">כניסה</button>
    </form>
</template>

<script>
import store from "@/store";

export default {
    name: "OtpConfirmation",
    data(){
        return {
            credentials: {
                otp: ''
            }
        }
    },
    methods: {
        async login(){
					if(await this.$store.dispatch('otpConfirmation', this.credentials)){
							await this.$router.push({name: 'home'})
					}
        }
    },
    beforeRouteEnter(to, from, next){
        if(store.getters.otpKey){
            next()
        }else{
            next('/login')
        }
    }
}
</script>

<style scoped>

</style>
